import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import OnboardingModal from '../tc-ui/onboardingModal';
import QuickLinksItem from './QuickLinksItem';
import DashboardRow from './DashboardRow';
import Stats from './Stats';
import StatItem from './StatItem';
import Updates from './Updates';

import { filterConnections } from '../../stores/connections/connections-actions';
import { searchCountOnly } from '../../stores/partner-finder/partnerFinder-actions';
import { closeOnboardingDialog, initDashboard } from '../../stores/dashboard/actions';

class DashboardContainer extends Component {

  constructor(props, context) {
    super(props);
    // if (props.user.contractingShell) context.router.push('/profile');

    this.handleOnboardingClose = this.handleOnboardingClose.bind(this);
  }

  componentWillMount() {
    const { dispatch, user } = this.props;
    dispatch(filterConnections({ 'status': 'requests' }));
    const partnerFinderSearchParams = { log: false };
    partnerFinderSearchParams.destinationsSold = partnerFinderSearchParams.destinationsSold || [];
    const country = user.company.address.country;

    partnerFinderSearchParams.companyType = partnerFinderSearchParams.companyType || (user.user.type === 'Contractor' ? 'Supplier' : 'Contractor');
    if (partnerFinderSearchParams.companyType === 'Contractor') {
      partnerFinderSearchParams.destinationsSold = [country];
      partnerFinderSearchParams.country = undefined;
    } else {
      partnerFinderSearchParams.destinationsSold = [];
      partnerFinderSearchParams.country = country;
    }
    partnerFinderSearchParams.isForPremiumUser = (user.billingPlan === 'connected' || user.billingPlan === 'unlimited');
    partnerFinderSearchParams.page = undefined;
    dispatch(searchCountOnly(partnerFinderSearchParams, false, false));
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(initDashboard());
  }

  handleOnboardingClose(e) {
    const { dispatch } = this.props;
    if (e) { e.preventDefault(); }
    dispatch(closeOnboardingDialog());
  }

  handleFinishProfileModalClose() {
    this.setState({ finishProfileModalOpen: false });
  }

  render() {
    const {
      connections,
      connectionsStats,
      dashboard,
      marketingMaterials: {
        media,
      },
      settings,
      profile,
      partnerFinder,
      user,
      user: {
        user: { firstName },
      },
      lockedPartnersBanner,
    } = this.props;

    const quickLinks = {
      addExistingPartners: {
        buttonText: 'Grow Your Network',
        icon: require('../../../www/images/email.svg'),
        primaryText: 'Quickly Add Your Existing Partners and connect with partners you already work with.',
        routeName: '/connections/add-connections',
        secondaryText: '',
      },
      completeProfile: {
        buttonText: 'Complete Your Profile',
        icon: require('../../../www/images/checklist.svg'),
        primaryText: `Your profile is ${profile.marketingReadinessPercentage ? `only ${profile.marketingReadinessPercentage}%` : 'not'} complete.`,
        routeName: '/profile',
        secondaryText: 'Show potential partners all you have to offer.',
      },
      searchPartnerFinder: {
        buttonText: 'Start Your Search',
        icon: require('../../../www/images/search-partnerfinder.svg'),
        primaryText: `There are ${partnerFinder.total} ${user.user.type === 'Contractor' ? 'suppliers' : 'buyers'} in ${user.company.address.country}.`,
        routeName: '/partner-finder/results',
        secondaryText: 'Search for new partners.',
      },
      inviteTeam: {
        buttonText: 'Invite Your Team',
        icon: require('../../../www/images/invite-team.svg'),
        primaryText: 'TourConnect is better with friends.',
        routeName: '/settings/manage-users',
        secondaryText: 'Invite your collegues to join.',
      },
      uploadMarketingMaterial: {
        buttonText: 'Upload Now',
        icon: require('../../../www/images/files.svg'),
        primaryText: 'A single location to store and send your marketing assets.',
        routeName: '/profile#marketing-materials',
        secondaryText: '',
      },
      contractorRequestRates: {
        buttonText: 'Send Rate Requests',
        icon: require('../../../www/images/incoming-contracts.svg'),
        primaryText: 'Ready to make rates easier?',
        routeName: '/contracting/contract-list/recent',
        secondaryText: 'Request rates from your suppliers.',
      },
      supplierSendRates: {
        buttonText: 'Create A Rate Template',
        icon: require('../../../www/images/send-rates.svg'),
        primaryText: 'Ready to automatically send your annual rates to all your partners around the world?',
        routeName: '/contracting',
        secondaryText: '',
      },
    };

    const onboardingModalSlides = [
      {
        header: 'Congratulations!',
        subHeader: 'Your company is now part of the TourConnect network.',
        content: <div>
            <img style={{ minHeight: '100%', padding: '25px' }} src={require('../../../www/images/trophy.svg')} />
            <div style={{ padding: '10px 0' }}>
              <h4 style={{ color: 'rgba(0, 0, 0, 0.54)' }}>Let's take a moment to show you how TourConnect works.</h4>
            </div>
          </div>,
      },
      {
        header: 'Your TourConnect Profile',
        subHeader: 'TourConnect helps showcase your products and services.',
        content: <div>
            <div style={{ display: 'inline-block', padding: '25px', width: '50%', verticalAlign: 'top' }}>
              <img style={{ maxWidth: '100%' }} src={require('../../../www/images/profileOnboarding.png')} />
            </div>
            <div style={{ display: 'inline-block', padding: '25px', textAlign: 'left', width: '50%', verticalAlign: 'top' }}>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}>Your TourConnect profile is where your partners find information about your products, contacts, and industry memberships.</p>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}>A complete, and up-to-date, profile helps to maintain a strong relationship &mdash; driving more business opportunities.</p>
            </div>
          </div>,
        buttonText: "Let's Go",
      },
      {
        header: 'PartnerFinder',
        subHeader: 'TourConnect makes it easier to find new partners.',
        content: <div>
            <div style={{ display: 'inline-block', padding: '25px', width: '50%', verticalAlign: 'top' }}>
              <img style={{ maxWidth: '100%' }} src={require('../../../www/images/partnerFinderOnboarding.png')} />
            </div>
            <div style={{ display: 'inline-block', padding: '25px', textAlign: 'left', width: '50%', verticalAlign: 'top' }}>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}>Quickly search for the type of partners you need to grow your business.</p>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}>Get detailed information about potential partners to decide if they are a fit for your business.</p>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}>Send a connection request to kickstart a potential new relationship.</p>
            </div>
          </div>,
        buttonText: 'Finding New Partners',
      },
      {
        header: 'Rates & Contracts',
        subHeader: 'TourConnect brings organization to the contracting process.',
        content: <div>
            <div style={{ display: 'inline-block', padding: '25px', width: '50%', verticalAlign: 'top' }}>
              <img style={{ maxWidth: '100%' }} src={require('../../../www/images/contractingOnboarding.png')} />
            </div>
            <div style={{ display: 'inline-block', padding: '25px', textAlign: 'left', width: '50%', verticalAlign: 'top' }}>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}>Create and manage rate templates for your products and services - so you'll never have to duplicate effort again.</p>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}>Easily send contracts and updates to all of your partners - then know when they have been viewed or loaded.</p>
            </div>
          </div>,
        buttonText: 'Automating Rates & Contracts',
      },
    ];

    return (
      <div style={{ margin: '0 auto', maxWidth: '1232px', paddingTop: '64px' }}>
        {lockedPartnersBanner}
        <DashboardRow>
          <div style={{ width: '100%', padding: '20px 0' }}>
            <h1 style={{ fontWeight: 300, fontSize: '28px', lineHeight: '36px', margin: 0, textAlign: 'center' }}>{`Welcome to TourConnect${firstName ? `, ${firstName}.` : '!'}`}</h1>
            <h2 style={{ fontWeight: 300, fontSize: '16px', lineHeight: '24px', margin: 0, padding: 0, textAlign: 'center' }}>Take a look at new things going on in your Network</h2>
          </div>
        </DashboardRow>
        <DashboardRow>
          { profile.isMarketingReady ?
            <QuickLinksItem {...quickLinks.searchPartnerFinder} />
            :
            <QuickLinksItem {...quickLinks.completeProfile} />
          }
          { settings.usersArray.length > 1 ?
            <QuickLinksItem {...quickLinks.addExistingPartners} />
            :
            <QuickLinksItem {...quickLinks.inviteTeam} />
          }
          { user.user.type === 'Contractor' ?
            <QuickLinksItem {...quickLinks.contractorRequestRates} />
            :
            profile.acctCreationReason === 'send-rates' && profile.isMarketingReady ? <QuickLinksItem {...quickLinks.supplierSendRates} /> : <QuickLinksItem {...quickLinks.uploadMarketingMaterial} />
          }
        </DashboardRow>
        <DashboardRow>
          <Updates items={connections.items} title="Recent Updates" />
          <Stats disabled={connectionsStats.totalCount < 5} title="Quick Stats" style={{ padding: '15px' }}>
            <StatItem statName="Connections" statValue={connectionsStats.totalCount} style={{ display: 'inline-block', marginBottom: '15px', textAlign: 'center', width: 'calc(100%/2)' }} />
            <StatItem statName="Profile Views" statValue={ (profile.profileViews && profile.profileViews.length) || 0 } style={{ display: 'inline-block', marginBottom: '15px', textAlign: 'center', width: 'calc(100%/2)' }} />
            <StatItem statName="Storage" statValue={`${Math.ceil(media.length ? media.map(m => m.size && m.size !== 'external' ? parseFloat(m.size) : 0).reduce((total, size) => total + size, 0) : '0')}mb`} style={{ display: 'inline-block', textAlign: 'center', width: 'calc(100%/2)' }} />
            <StatItem statName="Invitations Sent" statValue={connectionsStats.pendingInviteCount} style={{ display: 'inline-block', textAlign: 'center', width: 'calc(100%/2)' }} />
          </Stats>
        </DashboardRow>
        {user.user.type !== 'Contractor' && <OnboardingModal
          showOnboardingDialog={dashboard.showOnboardingDialog}
          handleModalClose={this.handleOnboardingClose}
          lastSlideButton="Next: Start Using TourConnect"
          onLastSlideButtonClick={this.handleOnboardingClose}
          slides={onboardingModalSlides}
        />}
    </div>
    );
  }
}

DashboardContainer.propTypes = {
  connections: PropTypes.object,
  connectionsStats: PropTypes.object,
  dashboard: PropTypes.object,
  dispatch: PropTypes.func,
  marketingMaterials: PropTypes.object,
  partnerFinder: PropTypes.object,
  profile: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = (store) => (
  {
    connections: store.connections.toJS(),
    connectionsStats: store.connectionsStats.toJS(),
    dashboard: store.dashboard,
    marketingMaterials: store.marketingMaterials.mainReducer.toJS(),
    partnerFinder: store.partnerFinder.toJS(),
    profile: store.profile.toJS(),
    settings: store.settings.toJS(),
    user: store.user.toJS(),
  }
);

DashboardContainer.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(DashboardContainer);



// WEBPACK FOOTER //
// ./src/app/components/dashboard/index.jsx